import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import Button from "./Button.jsx";
import renderIcon from "./renderIcon.jsx";
import useThemeProps from "./useThemeProps.jsx";

const IconButtonRoot = styled(Button)`
  display: inline-flex;
  place-content: center;
`;

export default function IconButton(props) {
  // eslint-disable-next-line no-unused-vars
  const theme = useTheme();
  props = useThemeProps({ props, name: "IconButton" });
  let { icon, name, size, src, label, ...restProps } = props;
  return (
    <IconButtonRoot aria-label={label} {...restProps}>
      {renderIcon(icon, { name, size, src })}
    </IconButtonRoot>
  );
}
